export type DogVaccineType = "rabies" | "dhpp" | "bordetella" | "leptospirosis" | "influenza" | "other";

export const DOG_VACCINE_TYPES: { value: DogVaccineType; label: string }[] = [
  { value: "rabies",        label: "Rabies" },
  { value: "dhpp",         label: "DHPP / DAPP (Distemper, Parvo, Adenovirus, Parainfluenza)" },
  { value: "bordetella",   label: "Bordetella (Kennel Cough)" },
  { value: "leptospirosis", label: "Leptospirosis" },
  { value: "influenza",    label: "Canine Influenza (H3N2 / H3N8)" },
  { value: "other",        label: "Other / General Health Record" },
];

export interface IDogAttachment {
  _id: string;
  type: DogVaccineType;
  file_url: string;
  file_name: string;
  file_size: number;
  mime_type: string;
  expiry_date: string;   // ISO 8601 date — required
  uploaded_at: string;   // ISO 8601 datetime
  notes?: string;
}
